import { useContext, useEffect, useMemo, useRef, useState } from "react"
import { callautopopulate } from "../../../services/callautopop"
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { calculateWordsFromString, convertTo12HourFormat, convertTo24HourFormat, dateConvert, timeStringToDate } from "../../../utils/Helper";
import { ToastContext } from "../../../context/ToastContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCommon } from "../../Common/useCommon";

export const useRegularization = ({ regularization, handleClose, apiCall }) => {
    const { showSuccess, showInfo, showError } = useContext(ToastContext);
    const { getValuePermission } = useCommon();
    const [formValue, setFormValue] = useState({});
    const [option, setOptions] = useState([]);
    const [regularizationList, setRegularizationList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [status, setStatus] = useState("P");
    const [confirmationPopup, setConfirmationPopup] = useState({});
    const [userCode, setUserCode] = useState("")
    const tagRef = useRef(null);

    const colDef = [
        {
            field: "user_display_name",
            headerName: "Employee Name",
            width: 120,
        },
        {
            field: "shift_date",
            headerName: "Shift Date",
            width: 80,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>{params?.value && dateConvert(params?.value, "day-month-year")}</div>
                )
            }
        },
        {
            field: "shift_startdate",
            headerName: "Shift In",
            width: 80,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>{params?.value && convertTo12HourFormat(params?.value)}</div>
                )
            }
        },
        {
            field: "shift_enddate",
            headerName: "Shift Out",
            width: 80,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>{params?.value && convertTo12HourFormat(params?.value)}</div>
                )
            }
        },
        {
            field: "original_starttime",
            headerName: "Tap In",
            width: 80,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                const shiftStart = params?.data?.shift_startdate
                const classname = dateConvert((params?.value && timeStringToDate(params?.value)), "iso-string") <= dateConvert(shiftStart && timeStringToDate(shiftStart), "iso-string") ? "text-success" : "text-danger"
                return (
                    <div className={classname}>{params?.value && convertTo12HourFormat(params?.value)}</div>
                )
            }
        },
        {
            field: "original_endtime",
            headerName: "Tap Out",
            width: 80,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                const shiftEnd = params?.data?.shift_enddate
                const classname = dateConvert((params?.value && timeStringToDate(params?.value)), "iso-string") >= dateConvert(shiftEnd && timeStringToDate(shiftEnd), "iso-string") ? "text-success" : "text-danger"
                return (
                    <div className={classname}>{params?.value && convertTo12HourFormat(params?.value)}</div>
                )
            }
        },
        {
            field: "regularize_starttime",
            headerName: "Regularize In",
            width: 100,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>{params?.value && convertTo12HourFormat(params?.value)}</div>
                )
            }
        },
        {
            field: "regularize_endtime",
            headerName: "Regularize Out",
            width: 100,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>{params?.value && convertTo12HourFormat(params?.value)}</div>
                )
            }
        },
        {
            field: "regularize_reason",
            headerName: "Reason",
            width: 340,
            cellRenderer: (params) => {
                return (
                    <div title={params?.value}>{params?.value}</div>
                )
            }
        },
        {
            field: "request_status_name",
            headerName: "Action",
            width: 140,
            hide: status !== "P" || getValuePermission("regularize_approve_column"),
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>
                        {
                            <div className="d-flex gap-2 align-items-baseline justify-content-center ">
                                <label>
                                    <input
                                        type="radio"
                                        value="is_approved"
                                        className="c-pointer"
                                        onChange={(e) => setConfirmationPopup({ show: true, value: "A", data: params?.data, type: "status" })}
                                    />
                                    Approve
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        value="is_rejected"
                                        className="c-pointer"
                                        onChange={(e) => setConfirmationPopup({ show: true, value: "R", data: params?.data, type: "status" })}
                                    />
                                    Reject
                                </label>
                            </div>
                        }
                    </div>
                )
            }
        },

        {
            field: "approve_by",
            headerName: status == "A" ? "Approved By" : "Rejected By",
            hide: status == "P",
            width: 120,
            cellRenderer: (params) => {
                return (
                    <div title={params?.value}>{params?.value}</div>
                )
            }
        },
        {
            field: "delete",
            headerName: "Delete",
            width: 50,
            hide:status !== "P",
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>
                        {
                            params.data?.user_code === userCode ? <FontAwesomeIcon
                                icon="fa-solid fa-trash"
                                className="remove"
                                onClick={(e) => setConfirmationPopup({ show: true, data: params?.data, type: "delete" })}
                            /> : ""
                        }
                    </div>

                )
            }
        },
    ]

    useEffect(() => {
        setFormValue({
            startTime: timeStringToDate(regularization?.data?.insights_starttime, regularization?.data?.day_date),
            endTime: timeStringToDate(regularization?.data?.insights_endtime, regularization?.data?.day_date),
        })
    }, [regularization?.data])

    useEffect(() => {
        callautopopulate("regularize_reason", "user_info").then((res) => {
            setOptions(res?.regularize_reason)
            setUserCode(res?.user_info[0]?.user_code)
        }).catch((error) => {
            console.error("error", error)
        })
    }, [])

    const handleSubmit = async () => {
        try {
            if (!formValue?.startTime || !formValue?.endTime) {
                showInfo("Info", "Please enter a regularize in/out time.");
                return
            } else if (!formValue?.reason?.reasons) {
                showInfo("Info", "Please select a reason.");
                return
            } else if (formValue?.reason?.reasons?.toLowerCase() === "other" && (!formValue?.description || calculateWordsFromString(formValue?.description) < 5)) {
                showInfo("Info", "Remark should contain more than 5 words");
                return
            }
            const payload = {
                "regularize_date": regularization?.data?.day_date,
                "regularize_starttime": formValue?.startTime ? convertTo24HourFormat(dateConvert(new Date(formValue?.startTime), "time"), true) : "",
                "regularize_endtime": formValue?.endTime ? convertTo24HourFormat(dateConvert(new Date(formValue?.endTime), "time"), true) : "",
                "reason": formValue?.reason?.reasons?.toLowerCase() === "other" ? formValue?.description : formValue?.reason?.reasons
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTREGUlARIZEREQUEST"), payload);
            if (!res?.body?.error_status) {
                showSuccess("success", res?.body?.message)
                setFormValue({});
                apiCall()
                handleClose();
            } else {
                showError("error", res?.body?.errorMessage)
            }
        } catch (error) {
            console.error("error", error)
        }
    }

    useEffect(() => {
        getRegularizationList(status)
    }, [status])

    const getRegularizationList = async (flag) => {
        try {
            setLoader(true)
            const payload = {
                "status": flag
            }
            const res = await services.getInvokeRemote("POST", Urls("GETREGULARIZEREQUEST"), payload);
            if (!res?.error_status) {
                setRegularizationList(res?.body?.data);
            } else {
                setRegularizationList([]);
            }
            setLoader(false)
        } catch (error) {
            console.error(error)
        }
    }


    const handleRequest = async (value, data) => {
        try {
            const payload = {
                "regularize_date": data?.shift_date,
                "status": value,
                "requested_user_code": data?.user_code
            }
            const res = await services?.getInvokeRemote("POST", Urls("APPROVEREGULARIZEREQUEST"), payload);
            if (!res?.body?.data?.error_status) {
                showSuccess('Success', res.body.message);
                getRegularizationList(status);
                setConfirmationPopup({ show: false, data: null })
            }
            else {
                showError("Error", res.body.errorMessage);
            }
        } catch (error) {
            console.error(error)
        }
    }


    const handleDelete = async (data) => {
        try {
            const payload = {
                "shift_date": data?.shift_date,
                "requested_user_code": data?.user_code
            }
            const res = await services?.getInvokeRemote("POST", Urls("DELETEREGULARIZEREQUEST"), payload);
            if (!res?.body?.data?.error_status) {
                showSuccess('Success', res.body.message);
                getRegularizationList(status);
                setConfirmationPopup({ show: false, data: null })

            }
            else {
                showError("Error", res.body.errorMessage);
            }
        } catch (error) {
            console.error(error)
        }
    }


    return useMemo(() => ({
        formValue, setFormValue, option, handleSubmit, colDef, regularizationList, loader, getRegularizationList, status, setStatus, confirmationPopup, setConfirmationPopup, handleRequest, tagRef, handleDelete
    }), [formValue, setFormValue, option, handleSubmit, colDef, regularizationList, loader, getRegularizationList, status, setStatus, confirmationPopup, setConfirmationPopup, handleRequest, tagRef, handleDelete])
}